import { useQuery } from '@tanstack/react-query';

import { broadcastScheduleQueryKeys } from '@/features/broadcast-schedule/api/query-keys';
import { TProgramBroadcast } from '@/features/broadcast-schedule/types';
import { mediaManagerClient } from '@/lib/axios';
import { ExtractFnReturnType, QueryConfig } from '@/lib/react-query';

export async function getBroadcastScheduleById(id: string): Promise<TProgramBroadcast> {
  // Lets the failure reach React Query. Swallowing it resolved to `[]`, which on a
  // refetch replaced a good emission with an object that has no window: the review
  // header emptied and the cut form, finding none, accepted any cut. Rejecting keeps
  // the last emission read and only marks the query as failed.
  // The response interceptor returns the body, which axios types as the response.
  return mediaManagerClient.get(
    `api/v1/program_broadcasts/${id}`
  ) as unknown as Promise<TProgramBroadcast>;
}

type QueryFnType = typeof getBroadcastScheduleById;

interface UseResourcesParams {
  config?: QueryConfig<QueryFnType>;
  id: string;
}

export function useGetBroadcastScheduleById({ config, id }: UseResourcesParams) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    enabled: !!id,
    queryKey: broadcastScheduleQueryKeys.id(id),
    queryFn: () => getBroadcastScheduleById(id),
  });
}
